import React from 'react';
import { NavLink } from 'react-router-dom';
import Switcher from '../Elements/Switcher';

var bnr = require('./../../images/background/f-bg.jpg');

class Footer2 extends React.Component {
    render() {

        return (
            <>
                <footer className="site-footer footer-large footer-dark footer-wide">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top overlay-wraper bg-cover" style={{backgroundImage:"url(" + bnr + ")"}}>
                        <div className="overlay-main sx-bg-secondry opacity-08" />
                        <div className="container">
                            <div className="row">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_about">
                                        {/*<h4 class="widget-title">About Company</h4>*/}
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={"./"}>
                                                <img src={require('./../../images/property_logo.png')} alt="Infrio" />
                                            </NavLink>
                                        </div>
                                         <p>Plan I Build I Design</p>
                                         <p style={{whiteSpace: 'pre-line',textAlign:"left"}}>{`Better Spaces, Better Futures \n Infrio India delivers trusted architecture, construction, and infrastructure solutions from planning to execution.`}</p>
                                        <ul className="social-icons  sx-social-links">
                                            {/* <li><a href="https://www.behance.net/" className="fa fa-behance" target="_blank"></a></li> */}
                                            <li><a href="https://www.facebook.com/share/19HLdHfJ3u/?mibextid=wwXIfr" className="fa fa-facebook" target="_blank"></a></li>
                                            <li><a href="https://www.instagram.com/infrio_architects?utm_source=qr" className="fa fa-instagram" target="_blank"></a></li>
                                            <li><a href="https://www.youtube.com/@InfrioArchitects" className="fa fa-youtube-play" target="_blank" rel="noopener noreferrer"></a></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* RESENT POST */}
                                {/* <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget recent-posts-entry-date">
                                        <h5 className="widget-title">Resent Post</h5>
                                        <div className="widget-post-bx">
                                            <div className="widget-post clearfix">
                                                <div className="sx-post-date text-center text-uppercase text-white">
                                                    <strong className="p-date">15</strong>
                                                    <span className="p-month">Sep</span>
                                                    <span className="p-year">2022</span>
                                                </div>
                                                <div className="sx-post-info">
                                                    <div className="sx-post-header">
                                                        <h6 className="post-title"><NavLink to={"/blog-single"}>On these beams, we’re.</NavLink></h6>
                                                    </div>
                                                    <div className="sx-post-meta">
                                                        <ul>
                                                            <li className="post-author"><i className="fa fa-user" />By Admin</li>
                                                            <li className="post-comment"><i className="fa fa-comments" /> 28</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="widget-post clearfix">
                                                <div className="sx-post-date text-center text-uppercase text-white">
                                                    <strong className="p-date">17</strong>
                                                    <span className="p-month">Sep</span>
                                                    <span className="p-year">2022</span>
                                                </div>
                                                <div className="sx-post-info">
                                                    <div className="sx-post-header">
                                                        <h6 className="post-title"><NavLink to={"/blog-single"}>We’ll be a sensation for</NavLink></h6>
                                                    </div>
                                                    <div className="sx-post-meta">
                                                        <ul>
                                                            <li className="post-author"><i className="fa fa-user" />By Admin</li>
                                                            <li className="post-comment"><i className="fa fa-comments" /> 29</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="widget-post clearfix">
                                                <div className="sx-post-date text-center text-uppercase text-white">
                                                    <strong className="p-date">18</strong>
                                                    <span className="p-month">Sep</span>
                                                    <span className="p-year">2022</span>
                                                </div>
                                                <div className="sx-post-info">
                                                    <div className="sx-post-header">
                                                        <h6 className="post-title"><NavLink to={"/blog-single"}>We’ll be a sensation for</NavLink></h6>
                                                    </div>
                                                    <div className="sx-post-meta">
                                                        <ul>
                                                            <li className="post-author"><i className="fa fa-user" />By Admin</li>
                                                            <li className="post-comment"><i className="fa fa-comments" /> 29</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                {/* USEFUL LINKS */}
                                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title">Useful links</h5>
                                        <ul>
                                            <li><NavLink to={"/about-us"}>About</NavLink></li>
                                            <li><NavLink to={"/services"}>Services</NavLink></li>
                                            <li><NavLink to={"/project-grid-5-columns"}>Showcase</NavLink></li>
                                            <li><NavLink to={"/blog"}>Blog</NavLink></li>
                                            <li><NavLink to={"/contact-us"}>Contact Us</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* CONTACT US */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_address_outer">
                                        <h5 className="widget-title">Contact Us</h5>
                                        <ul className="widget_address">
                                            <li>1st floor, Above Swastik Plywood, 27, New Grain Mandi, Kota, 324005</li>
                                            <li>info@infrioindia.com</li>
                                            <li>(+91) 900-1457-000</li>
                                            <li>(+91) 785-1820-559</li>
                                        </ul>
                                    </div>
                                </div>
                                 {/* MORE FROM US */}
                                 <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title">More form Us</h5>
                                        <ul>
                                            <li><a target="_blank" rel="noopener noreferrer" href={"https://www.solar.infrioindia.com/"}>Infrio Solar</a></li>
                                            <li><a target="_blank" rel="noopener noreferrer" href={"https://www.property.infrioindia.com/"}>Infrio Properties</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="call-to-action-wrap">
                                <div className="row">
                                    <div className="col-lg-7 col-md-6">
                                        <div className="call-to-action-left">
                                                 <h5 className="text-uppercase m-b10 m-t0 youtube-subscribe-heading">
                                                    <a className="youtube-subscribe-link" href="https://www.youtube.com/@InfrioArchitects" target="_blank" rel="noopener noreferrer" style={{ color: "inherit" }}>
                                                        Subscribe to our Youtube channel!
                                                    </a>
                                                </h5>
                                            <span>Never Miss Anything From Infrio By Signing Up To Our Youtube channel.</span>
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-5 col-md-6">
                                        <div className="call-to-action-right">
                                            <div className="widget_newsletter">
                                                <div className="newsletter-bx">
                                                    <form role="search" method="post" action="">
                                                        <div className="input-group">
                                                            <input name="news-letter" className="form-control" placeholder="ENTER YOUR EMAIL" type="text" />
                                                            <span className="input-group-btn">
                                                                <button type="button" className="site-button"><i className="fa fa-paper-plane-o" /></button>
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="sx-footer-bot-left">
                                    <span className="copyrights-text">© 2025 Your Company. Designed By Ample eBusiness.</span>
                                </div>
                                <div className="sx-footer-bot-right">
                <NavLink to="/privacy-policy" className="text-white me-3">
                    Privacy Policy
                </NavLink>
                {" | "}
                <NavLink to="/terms-conditions" className="text-white ms-3">
                    Terms & Conditions
                </NavLink>
            </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <Switcher />
            </>
        );
    };
};

export default Footer2;
